import { Fragment } from 'react';

import {
  StyledDescriptionDetails,
  StyledDescriptionList,
  StyledDescriptionTerm,
  StyledWrap,
} from './DescriptionList.styled';
import type { DescriptionListVariant } from './DescriptionList.types';

export type DescriptionListData = {
  id: string;
  term: string;
  description: string;
};

export interface IDescriptionListProps {
  className?: string;
  data: DescriptionListData[];
  variant?: DescriptionListVariant;
}

export const DescriptionList = ({
  className,
  data,
  variant = 'primary',
}: IDescriptionListProps) => {
  return (
    <StyledDescriptionList className={className} $variant={variant}>
      {variant === 'primary'
        ? data.map(({ id, term, description }) => (
            <Fragment key={id}>
              <StyledDescriptionTerm>{term}</StyledDescriptionTerm>
              <StyledDescriptionDetails>{description}</StyledDescriptionDetails>
            </Fragment>
          ))
        : data.map(({ id, term, description }) => (
            <StyledWrap key={id}>
              <StyledDescriptionTerm>{term}</StyledDescriptionTerm>
              <StyledDescriptionDetails>{description}</StyledDescriptionDetails>
            </StyledWrap>
          ))}
    </StyledDescriptionList>
  );
};
